import { render, staticRenderFns } from "./AIChatWidgetTemplateSlider.vue?vue&type=template&id=1899ff02&scoped=true"
import script from "./AIChatWidgetTemplateSlider.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetTemplateSlider.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetTemplateSlider.vue?vue&type=style&index=0&id=1899ff02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1899ff02",
  null
  
)

export default component.exports